const GALLERY = [
  {
    url: "https://images.unsplash.com/photo-1651980765175-ee248a9d55ba?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1MTN8MHwxfHNlYXJjaHwxfHx2aW50YWdlJTIwZGlydCUyMGJpa2V8ZW58MHx8fHwxNzg2ODIxNjU0fDA&ixlib=rb-4.1.0&q=85",
    title: "Evo Restoration",
    year: "1985 YZ250 · Full ground-up",
  },
  {
    url: "https://images.unsplash.com/photo-1534755563369-ad37931ac77b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjY2NzF8MHwxfHNlYXJjaHwxfHxtb3RvcmN5Y2xlJTIwZW5naW5lJTIwcGFydHN8ZW58MHx8fHwxNzg2ODIxNjU1fDA&ixlib=rb-4.1.0&q=85",
    title: "Engine Teardown",
    year: "CR500 · Full rebuild",
  },
  {
    url: "https://images.unsplash.com/photo-1636761358757-0a616eb9e17e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjV8MHwxfHNlYXJjaHwyfHxtZWNoYW5pYyUyMHJlcGFpcmluZyUyMG1vdG9yY3ljbGV8ZW58MHx8fHwxNzg2ODIxNjU0fDA&ixlib=rb-4.1.0&q=85",
    title: "Bearing Work",
    year: "Swing arm & linkage",
  },
  {
    url: "https://images.unsplash.com/photo-1606497058128-19b758a3dd88?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MjJ8MHwxfHNlYXJjaHw0fHxtb3RvY3Jvc3MlMjByYWNpbmclMjBkaXJ0fGVufDB8fHx8MTc4NjgyMTY1NXww&ixlib=rb-4.1.0&q=85",
    title: "VMXDN Ready",
    year: "Race weekend prep",
  },
];

export default function Gallery() {
  return (
    <div data-testid="gallery-page" className="max-w-7xl mx-auto px-4 sm:px-8 py-16 sm:py-24">
      <div className="mb-14 max-w-3xl">
        <span className="font-mono text-xs uppercase tracking-widest text-orange-500">— The Work</span>
        <h1 className="font-display text-5xl sm:text-7xl uppercase mt-2">Bikes We've Built.</h1>
      </div>
      <div className="grid sm:grid-cols-2 gap-6">
        {GALLERY.map((g, i) => (
          <figure key={i} data-testid={`gallery-item-${i}`} className="relative group overflow-hidden border border-white/10">
            <img src={g.url} alt={g.title} className="w-full aspect-[4/3] object-cover transition-all duration-500 group-hover:scale-105 grayscale group-hover:grayscale-0" />
            <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-zinc-950 via-zinc-950/80 to-transparent p-6">
              <h3 className="font-display uppercase text-2xl">{g.title}</h3>
              <p className="font-mono text-xs uppercase tracking-widest text-zinc-400">{g.year}</p>
            </figcaption>
          </figure>
        ))}
      </div>
    </div>
  );
}
